import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { useReporting } from '@/reporting';
import { isProd } from '@/utils/env';
import { useLendingModalContext } from './LendingModalContext';
import { PrioritiesType, ProductsType } from './types';
import useLendingFormContext from './useLendingFormContext';

const getProductOptionsForCalendly = (selectedProducts: ProductsType[]) => {
  return selectedProducts
    .map((product) => {
      switch (product) {
        case 'Asset-Based Lending':
          return 1;
        case 'Invoice Financing':
          return 2;
        case 'Term Loans':
          return 3;
        case 'Purchase Order Financing':
          return 4;
        case 'Production Financing':
          return 5;
        case 'Receivables Finance':
          return 6;
      }
    })
    .join(',');
};

const getPrioritiesOptionsForCalendly = (selectedPriorities: (PrioritiesType | string)[]) => {
  return selectedPriorities
    .map((priority) => {
      switch (priority) {
        case 'Payroll':
          return 1;
        case 'Production':
          return 2;
        case 'Stabilize cash flow':
          return 3;
        case 'Working capital':
          return 4;
        case 'Other':
          return 5;
      }
    })
    .join(',');
};

const ScheduleStep = () => {
  const { trackEnterpriseEvent } = useReporting();
  const { setModalStep, setHasSelectedDateAndTime, referrer } = useLendingModalContext();
  const { watch } = useLendingFormContext();
  const { contact, goals } = watch();
  const isProdEnv = isProd();
  // Do not schedule to Lending Advisor's Calendly account in lower environments
  const url = isProdEnv
    ? 'https://calendly.com/c2fo-lending-connections/c2fo-lending-connections'
    : 'https://calendly.com/kaylee-rauso-c2fo/30min';

  useCalendlyEventListener({
    onEventScheduled: () => {
      setModalStep('success');
      trackEnterpriseEvent('lending::modal::schedule::completed', { referrer });
    },
    onDateAndTimeSelected: () => {
      setHasSelectedDateAndTime(true);
      trackEnterpriseEvent('lending::modal::date-time::completed', { referrer });
    },
  });

  return (
    <div className="border border-gray-200">
      <InlineWidget
        url={url}
        prefill={{
          name: contact.name,
          email: contact.email,
          customAnswers: {
            a1: contact.jobTitle,
            a2: contact.phoneNumber,
            a3: contact.company,
            a4: contact.annualRevenue + ' USD',
            a5: contact.customers,
            a6: goals.capitalAmount,
            a7: getPrioritiesOptionsForCalendly(goals.priorities),
            a8: goals.successfulFundingExperience,
            a9: getProductOptionsForCalendly(goals.products),
            a10: goals.favoriteMeal,
          },
        }}
        pageSettings={{ hideLandingPageDetails: true, hideEventTypeDetails: true }}
      />
    </div>
  );
};

export default ScheduleStep;
